import { useState, useEffect } from "react";
import Marquee from "react-fast-marquee";
import "../styles/PartnerLogos.scss";

import Sbi from '../assets/partners/sbi.jpg';
import Pnb from '../assets/partners/pnb.jpg';
import Bom from '../assets/partners/bank-of-mh.jpg';
import Au from '../assets/partners/au-bank.jpg';

import Adni from '../assets/partners/adani.jpg';
import Ware from '../assets/partners/waaree.jpg';
import Rayzon from '../assets/partners/rayzon.jpg';
import Vikaram from '../assets/partners/vikaram.jpg';
import Sungrow from '../assets/partners/sungrow.jpg';
import Wattpower from '../assets/partners/wattpower.jpg'
import Renew from '../assets/partners/renewsys.jpg';
import Jakson from '../assets/partners/jakson.jpg';
import Secure from '../assets/partners/secure.jpg';
import Apar from '../assets/partners/apar.jpg';
import Kei from '../assets/partners/kei-cables.jpg';
import Havells from '../assets/partners/havells.jpg';

import Rrecl from '../assets/partners/rrecl.jpg';
import AlmerVidyut from '../assets/partners/almer-vidyut.jpg';
import RjVidyut from '../assets/partners/rj-vidyut.jpg';
import Ntpc from '../assets/partners/ntpc.jpg';
import JdhVidyut from '../assets/partners/jdh-vidyut.jpg';
import Jvvnl from '../assets/partners/jvvnl.jpg';
import Seci from '../assets/partners/seci.jpg';
import Guvnl from '../assets/partners/guvnl.jpg';
import Urja from '../assets/partners/urja.jpg';


// 

const partners = {
  financial: [
    { name: "SBI", logo: Sbi },
    { name: "Punjab National Bank", logo: Pnb },
    { name: "AU Bank", logo: Au },
    { name: "Bank of Maharashtra", logo: Bom }
  ],
  corporate: [
    { name: "Adani Solar", logo: Adni },
    { name: "Waaree", logo: Ware },
    { name: "Rayzon", logo: Rayzon },
    { name: "Vikram Solar", logo: Vikaram },
    { name: "Sungrow", logo: Sungrow },
    { name: "Wattpower", logo: Wattpower },
    { name: "RenewSys", logo: Renew },
    { name: "Jakson", logo: Jakson },
    { name: "Secure", logo: Secure },
    { name: "Apar", logo: Apar },
    { name: "Kei", logo: Kei },
    { name: "Havells", logo: Havells },
  ],
  government: [
    { name: "RRECL", logo: Rrecl },
    { name: "AlmerVidyut", logo: AlmerVidyut },
    { name: "RjVidyut", logo: RjVidyut },
    { name: "JdhVidyut", logo: JdhVidyut },
    { name: "Jvvnl", logo: Jvvnl },
    { name: "Guvnl", logo: Guvnl },
    { name: "SECI", logo: Seci },
    { name: "GVUNL", logo: Guvnl },
    { name: "Urja", logo: Urja },
  ]
};

const PartnerLogos = () => {
  const [imageErrors, setImageErrors] = useState({});
  const [visibleCategories, setVisibleCategories] = useState({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const categoryId = entry.target.dataset.categoryId;
            setVisibleCategories(prev => ({ ...prev, [categoryId]: true }));
          }
        });
      },
      { threshold: 0.1 }
    );

    const categories = document.querySelectorAll('.partner-category');
    categories.forEach(category => observer.observe(category));

    return () => {
      categories.forEach(category => observer.unobserve(category));
    };
  }, []);

  const handleError = (name) => {
    setImageErrors((prev) => ({ ...prev, [name]: true }));
  };

  const renderFinancialPartners = (title, list, categoryId) => (
    <section
      className={`partner-category pt-5 pb-3 ${visibleCategories[categoryId] ? 'visible' : ''}`}
      key={title}
      data-category-id={categoryId}
    >
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h3 className="section-heading text-center mb-4">{title}</h3>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-7 col-12">
            <div className="row g-3 ">
              {list.map((p, index) => (
                <div className="col-lg-3 col-md-6 col-6" key={p.name}>
                  <div
                    className="partner-card shadow px-3 py-2 h-100"
                    style={{ animationDelay: `${index * 0.1}s`, maxHeight: '80px' }}
                  >
                    {imageErrors[p.name] ? (
                      <div className="fallback-name">{p.name}</div>
                    ) : (
                      <img
                        src={p.logo}
                        alt={`${p.name} logo`}
                        loading="lazy"
                        onError={() => handleError(p.name)}
                        className="img-fluid"
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  const renderMarqueePartners = (title, list, categoryId, direction = "left") => (
    <section
      className={`partner-category marquee-section overflow-hideen mb-0 ${visibleCategories[categoryId] ? 'visible' : ''}`}
      key={title}
      data-category-id={categoryId}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <h3 className="section-heading text-center my-4">{title}</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="">
              <Marquee
                direction={direction}
                speed={50}
                pauseOnHover={true}
                className="partner-marquee"
              >
                {list.map((p, index) => (
                  <div
                    className="marquee-partner-item"
                    key={`${p.name}-${index}`}
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div className="partner-logo-wrapper overflow-hidden">

                      <img
                        src={p.logo}
                        alt={`${p.name} logo`}
                        loading="lazy"
                        onError={() => handleError(p.name)}
                        className="img-fluid"
                      />
                    </div>
                  </div>
                ))}
              </Marquee>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  return (
    <section className="partner-section section-padding" id="partners">
      <div className="container-fluid text-center">
        <div className="row">
          <div className="col-12">
            <h2 className="section-title text-center mb-2">Our Trusted Partners</h2>
          </div>
        </div>
      </div>

      {renderFinancialPartners("Financial Partners", partners.financial, "financial")}
      {renderMarqueePartners("Corporate Partners", partners.corporate, "corporate", "left")}
      {renderMarqueePartners("Government Partners", partners.government, "government", "right")}
    </section>
  );
};

export default PartnerLogos;


